import PropTypes from 'prop-types'
import { DownloadJpg } from '../downloadJpg'

export const PanelDownloadJpg = ({ data }) => {
  return <DownloadJpg data={data} />
}

PanelDownloadJpg.propTypes = {
  data: PropTypes.shape({
    domId: PropTypes.string,
    arrName: PropTypes.array.isRequired,
    titleJpg: PropTypes.string,
    DownloadComponent: PropTypes.node,
    disabled: PropTypes.bool,
  }).isRequired,
}
